import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a693b7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "rel flex-col",
  id: "bussiness"
}

import Header from './layout/Header.vue'
import Footer from './layout/Footer.vue'
import { computed, ref, watch, nextTick, reactive, onMounted } from 'vue'
import { useStore } from 'vuex'
import { debounce } from 'lodash'
import CreateShop from '@/components/common/CreateShop.vue'
import Extension from '@/components/common/Extension.vue'
import { ElScrollbar } from 'element-plus'
import bus from '@/util/useBus'
import { t } from '@/plugins/i18n'
import plugin from 'dayjs/plugin/customParseFormat'
import RuleChange from '@/components/memberModal/RuleChange.vue'
import LevelChange from '@/components/memberModal/LevelChange.vue'
import MemberExpire from '@/components/memberModal/MemberExpire.vue'
import SmcModal from '@/components/memberModal/SmcModal.vue'
import GuideMembership from '@/components/memberModal/GuideMembership.vue'
import PwdSecurity2 from '@/components/PwdSecurity/PwdSecurity2.vue'
import { useRoute, useRouter } from 'vue-router'
import { useRtfix, useSite, isJA } from '@/store'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const visible = computed(() => store.state.status.toCreateShop)
const trigger = computed(() => store.state.observe.trigger)
const langType = computed(() => store.state.bussiness.langType)
const membership = store.getters.membership
// 是否显示1688精选图
// const showSelected = computed(() =>
//   (!route.query.imageUrl &&
//     route.query.platformType !== 'AM' && regPath('list')) ||
//   regPath('index/pure'))
const route = useRoute()

const router = useRouter()
const scrollbarRef: any = ref<InstanceType<typeof ElScrollbar>>()

const handle = debounce(({ scrollTop }) => {
  store.commit('observe/scroll', scrollTop)
}, 40)

watch(trigger, ({ scroll }) => {
  if (scroll) {
    scrollbarRef.value.setScrollTop(scroll)
  }
})

const regPath = (path: string) => {
  const reg = new RegExp('(ja|ko|en)/(' + path + ')')
  return reg.test(route.path as string)
}

const elScrollTo = (value: number) => {
  if (scrollbarRef.value) {
    scrollbarRef.value.setScrollTop(value)
  }
}

bus.on('elScrollTo', (val: number) => {
  elScrollTo(val)
})

const buss = reactive(store.state.bussiness)
const jumpToSearch = () => {
  store.commit('bussiness/platformType', 'AM')
  const keyword = route.query.keyword || (isJA() ? t('1688国家货盘') : t('1688严选'))
  buss.keyword = keyword
  const query: any = {
    ...route.query,
    schannel: 2,
    platformType: 'AM',
    keyword: keyword
  }
  router[route.name?.toString().includes('list') ? 'replace' : 'push'](
    useRtfix('list', { query })
  )
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(ElScrollbar), {
    ref: (_value, _refs) => {
      _refs['scrollbarRef'] = _value
      scrollbarRef.value = _value
    },
    height: "100%",
    onScroll: _unref(handle),
    always: "",
    "wrap-class": "scroll-container-outermost"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Header),
        _createElementVNode("section", null, [
          _createVNode(_component_router_view)
        ]),
        _createVNode(Footer),
        (_unref(visible))
          ? (_openBlock(), _createBlock(CreateShop, {
              key: 0,
              modelValue: _unref(visible),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).commit('status/toCreateShop', false))),
              onOk: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).dispatch('route/updateUser')))
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createVNode(Extension),
        (_unref(store).getters.isLogin)
          ? (_openBlock(), _createBlock(RuleChange, { key: 1 }))
          : _createCommentVNode("", true),
        _createVNode(GuideMembership),
        (_unref(membership).templateLevel)
          ? (_openBlock(), _createBlock(LevelChange, { key: 2 }))
          : _createCommentVNode("", true),
        _createVNode(SmcModal)
      ])
    ]),
    _: 1
  }, 8, ["onScroll"]))
}
}

})